import { useCallback, useMemo, useState } from 'react';

import { useTranslation } from '@cx-modules/i18n-provider';
import { type ButtonGroupItem } from '@cx-modules/ui';

const buttonOptions: ButtonGroupItem<'odds' | 'offers'>[] = [
  {
    active: true,
    id: 'odds',
    label: 'ODDS',
  },
  {
    active: false,
    id: 'offers',
    label: 'OFFERS',
  },
];

export const useSwitchCellContent = (): {
  contentType: 'odds' | 'offers';
  filterClicked: (id: 'odds' | 'offers') => void;
  filters: ButtonGroupItem<'odds' | 'offers'>[];
} => {
  const { t } = useTranslation('label');
  const [filters, setFilters] = useState(
    buttonOptions.map(buttonOption => ({
      ...buttonOption,
      label: t(buttonOption.label, { ns: 'label' }),
    })),
  );

  const filterClicked = useCallback((id: 'odds' | 'offers') => {
    setFilters(prev => prev.map(filter => ({ ...filter, active: filter.id === id })));
  }, []);

  const activeButton = useMemo(() => filters.find(f => f.active), [filters]);
  const contentType = typeof activeButton !== 'undefined' ? activeButton.id : 'odds';

  return { contentType, filterClicked, filters };
};
